<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent icono-titulo="fas fa-cash-register" texto-titulo="Nuevo recibo"></TituloComponent>
    <div class="main-card mb-3 card col-12">
      <div class="card-body">
        <div class="card-primary mb-3 card">
          <div class="card-header">
            <i class="fas fa-user header-icon icon-gradient bg-alternate"></i>Datos de cliente
          </div>
          <div class="card-body p-0">
            <div class="grid-menu grid-menu-2col" v-if="!cliente.id">
              <div class="no-gutters row">
                <div class="col-12">
                  <button
                    class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary opacity-7"
                    @click="modalCliente= true"
                    tabindex="1"
                  >
                    <i class="fas fa-user-check btn-icon-wrapper btn-icon-lg mb-3"></i>Seleccionar cliente
                  </button>
                </div>
              </div>
            </div>
            <div class="widget-content hoverable" v-else tabindex="1" @click="modalCliente = true">
              <div class="widget-content-wrapper row">
                <div class="widget-content-left col-12">
                  <h5 class="widget-heading text-success">{{cliente.nombre}}</h5>
                  <div class="widget-subheading opacity-10 row">
                    <span class="col-sm-auto col-12 text-alternate">
                      N° Doc/CUIL:
                      <b>{{cliente.numero_documento | cuil}}</b>
                    </span>
                    <span class="col-sm-auto col-12">
                      Saldo actual:
                      <b class="text-danger">${{cliente.saldo | numFormat('0,0.00')}}</b>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalSelectCliente
          v-if="modalCliente"
          @selectCliente="onSelectCliente"
          @cerrarModalCliente="modalCliente = false"
        ></ModalSelectCliente>
        <div class="row">
          <float-label label="Saldo pendiente:" clase="col-md-4 col-12" prepend="$">
            <input
              v-model="saldoAnterior"
              id="saldoAnterior"
              placeholder="0.00"
              type="number"
              step="0.01"
              class="form-control"
              :class="(enviado && (!$v.saldoAnterior.required || !$v.saldoAnterior.decimal)) ? 'is-invalid' : ''"
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.saldoAnterior.required"
              >Debe ingresar el monto recibido</div>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.saldoAnterior.decimal"
              >Solo se aceptan números</div>
            </template>
          </float-label>
          <div class="offset-md-4 col-md-4 col-12">
            <button
              class="btn btn-info btn-wide btn-block"
              type="button"
              @click="guardarSaldoAnterior"
            >Guardar saldo</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import ModalSelectCliente from "@/components/views/clientes/ModalSelectCliente";
import BlockUI from "@/components/loaders/BlockUI";
import { required, decimal } from "vuelidate/lib/validators";
import FloatLabel from "@/components/layouts/FloatLabel";
import axios from "axios";
import Swal from "sweetalert2";
import Cliente from "@/models/cliente";
export default {
  name: "AgregarSaldoAnterior",
  components: {
    TituloComponent,
    ModalSelectCliente,
    BlockUI,
    FloatLabel
  },
  data() {
    return {
      search: null,
      cliente: new Cliente(null, null, "", null, "", "", null, null, "", null),
      modalCliente: false,
      loading: false,
      saldoAnterior: null,
      enviado: false
    };
  },
  validations: {
    saldoAnterior: { required, decimal }
  },
  methods: {
    guardarSaldoAnterior() {
      this.enviado = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return false;
      }
      if(!this.cliente.id){
         Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `Seleccione un cliente.`
          });
        return false;
      }
      this.loading = true;
      let params = {
        saldo: this.saldoAnterior
      };
      axios
        .post("/clientes/saldo-anterior/"+this.cliente.id, params)
        .then(res => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `El saldo se guardó con éxito. El saldo actual es de $${this.$options.filters.numFormat(res.data.saldo, '0,0.00')}`
            });
            this.$router.push({ name: "ListarVentas" });
          }
        })
        .catch(error => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`
          });
        })
        .finally(() => (this.loading = false));
    },
    onSelectCliente(cliente) {
      this.cliente = cliente;
    }
  }
};
</script>
